import { OrderOperationType } from 'api/types/entity';

import { OrderOperationTypeForSearchParams } from '../types';

export const getOrderTypeBySearchParams = (
  searchParamOrderType: string | null
) => {
  switch (searchParamOrderType) {
    case OrderOperationTypeForSearchParams.SecuritiesPurchase:
      return OrderOperationType.SecuritiesPurchase;
    case OrderOperationTypeForSearchParams.SecuritiesSale:
      return OrderOperationType.SecuritiesSale;
    case OrderOperationTypeForSearchParams.SecuritiesWithdrawal:
      return OrderOperationType.SecuritiesWithdrawal;
    case OrderOperationTypeForSearchParams.SecuritiesDeposit:
      return OrderOperationType.SecuritiesDeposit;
    default:
      return undefined;
  }
};
